import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Spinner, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import './ReceiptPage.css';
import ReceiptView from '../components/ReceiptView';

const InvoicePage = () => {
    const { public_id } = useParams();
    const { i18n } = useTranslation();
    const { language, changeLanguage } = i18n;
    const location = useLocation();

    const [sale, setSale] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Effect for fetching sale data. Depends only on public_id.
    useEffect(() => {
        const fetchSale = async () => {
            try {
                // setLoading(true); // Removed as per instruction snippet
                const response = await api.get(`/public/sales/${public_id}`);
                setSale(response.data);
            } catch (err) {
                setError('Invoice not found or expired'); // Changed error message as per instruction snippet
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchSale();
    }, [public_id]);

    useEffect(() => {
        if (!loading && sale) {
            const queryParams = new URLSearchParams(location.search);
            if (queryParams.get('print') === 'true') {
                setTimeout(() => {
                    window.print();
                }, 500); // Small delay to ensure rendering
            }
        }
    }, [loading, sale, location.search]);

    // Effect for setting the language. Depends on the fetched sale data.
    useEffect(() => {
        const targetLang = sale?.business_language;
        if (targetLang && language !== targetLang) {
            changeLanguage(targetLang);
        }
    }, [sale, language, changeLanguage]);

    if (loading) {
        return <div className="receipt-wrapper"><Spinner animation="border" /></div>;
    }

    if (error) {
        return <div className="receipt-wrapper"><Alert variant="danger">{error}</Alert></div>;
    }

    if (!sale) {
        return null;
    }

    return (
        <div className="receipt-wrapper">
            <ReceiptView sale={sale} />
        </div>
    );
};

export default InvoicePage;
